import { ceil } from "@suse-o11y/ceil";
import { max } from "@suse-o11y/max";
import React from "react";

import { DocLink } from "../docLink/DocLink";
import { notification } from "../notification/Notification";

const BUCKET_WIDTH_IN_PIXELS = 15;

export const getBucketCount = (width: number) => max(1, ceil(width / BUCKET_WIDTH_IN_PIXELS, 0));

export const warningMessageHalfYearLimit = (): void =>
	void notification.warning({
		duration: 7,
		message: "You can not use a time interval larger than 6 months.",
		description: (
			<DocLink capture="noop" slug="ui-time-interval-limit">
				Learn more
			</DocLink>
		),
	});
